import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Mysqltemplate extends Component {
 
  render() {
    const course =[
      {    title: "Introduction to MySQL",    content: [      "Introduction to relational databases",      "Overview of MySQL",      "MySQL data types",      "MySQL storage engines",      "MySQL workbench"    ]
    },
    {
      title: "MySQL Installation and Configuration",
      content: [
        "Downloading and installing MySQL",
        "Configuration of MySQL server",
        "MySQL command line interface",
        "MySQL GUI tools"
      ]
    },
    {
      title: "MySQL Data Modeling",
      content: [
        "Data modeling concepts in MySQL",
        "Normalization and denormalization",
        "Creating tables and relationships",
        "Indexing in MySQL"
      ]
    },
    {
      title: "MySQL Querying",
      content: [
        "SELECT statement and its clauses",
        "Joining tables in MySQL",
        "Aggregating and grouping data",
        "Subqueries in MySQL"
      ]
    },
    {
      title: "MySQL Stored Procedures and Functions",
      content: [
        "Creating stored procedures and functions",
        "Variables and parameters in MySQL",
        "Flow control statements in MySQL",
        "Debugging and error handling in MySQL"
      ]
    },
    {
      title: "MySQL Triggers",
      content: [
        "Creating triggers in MySQL",
        "Trigger events and actions",
        "Old and new values in triggers",
        "Disabling and dropping triggers"
      ]
    },
    {
      title: "MySQL Administration",
      content: [
        "Backing up and restoring MySQL databases",
        "MySQL user management",
        "MySQL performance tuning",
        "MySQL security"
      ]
    },
    {
      title: "MySQL with PHP",
      content: [
        "Connecting to MySQL with PHP",
        "Executing queries in PHP",
        "Fetching data in PHP",
        "Prepared statements in PHP"
      ]
    },
    {
      title: "MySQL with Python",
      content: [
        "Connecting to MySQL with Python",
        "Executing queries in Python",
        "Fetching data in Python",
        "Prepared statements in Python"
      ]
    },
    {
      title: "MySQL with Node.js",
      content: [
        "Connecting to MySQL with Node.js",
        "Executing queries in Node.js",
        "Fetching data in Node.js",
        "Prepared statements in Node.js"
      ]
    },
    {
      title: "MySQL with Java",
      content: [
        "Connecting to MySQL with Java",
        "Executing queries in Java",
        "Fetching data in Java",
        "Prepared statements in Java"
      ]
    },
    {
      title: "MySQL Clustering",
      content: [
        "Introduction to MySQL clustering",
        "MySQL cluster architecture",
        "MySQL cluster setup",
        "MySQL cluster management"
      ]
    }
    ]

    const faqData = [
      {
        question: 'What is MySQL, and why should I take a MySQL course? ',
        answer:
          'MySQL is a popular open-source relational database management system (RDBMS) widely used for web applications, data warehousing, and various other applications. Taking a MySQL course or MySQL training will equip you with valuable skills in working with this powerful and versatile database.',
      },
      {
        question: 'What are the major advantages of using MySQL over other database systems?',
        answer:
          'MySQL is known for its speed, reliability, and ease of use. Its strengths include cross-platform compatibility, scalability, extensive community support, and a comprehensive set of features suitable for a wide range of applications.',
      },
      {
        question: 'How does MySQL compare to other relational databases like Oracle and SQL Server?',
        answer:
          'While all three databases provide similar relational database capabilities, MySQL is known for its ease of use and open-source nature, while Oracle and SQL Server are known for their enterprise-level features and support.'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with MySQL skills can pursue a variety of career opportunities such as Database Administrator, Data Engineer, Software Engineer, Business Intelligence Analyst, and Backend Developer.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Unlock the Power of MySQL with Our Comprehensive Training! To enroll in our MySQL course and MySQL training program, you should meet the following straightforward requirements: Possess a basic understanding of programming concepts, including variables, loops, conditional statements, and functions. Demonstrate strong problem-solving abilities and logical thinking skills to effectively work with MySQL's robust relational database management system. Embrace a passion for continuous learning, as MySQL is a widely-used technology with frequent updates and new features. Most importantly, commit to dedicating consistent effort throughout the duration of our MySQL course, allowing you to master this powerful open-source database effectively. "
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="MySQL reigns as the preeminent database management system software, entrusted with the monumental task of orchestrating relational databases. As an open-source database solution fostered by Oracle Company, MySQL has risen to preeminence, owing to its trifecta of attributes: speed, scalability, and user-friendliness. "/> */}
          
          <NewMainsec rating='4.7' students={"563"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="MySQL reigns as the preeminent database management system software, entrusted with the monumental task of orchestrating relational databases. As an open-source database solution fostered by Oracle Company, MySQL has risen to preeminence, owing to its trifecta of attributes: speed, scalability, and user-friendliness."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`MySQL is a popular open-source database management system used by businesses of all sizes to store, organize, and manage their data. At Learnsoft.org, we offer comprehensive MySQL training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of MySQL principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to MySQL or looking to expand your skillset, Learnsoft.org's MySQL ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your MySQL journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our MySQL course covers a wide range of topics, including database design, SQL programming, performance optimization, and security. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in MySQL. By the end of the course, you will be able to implement MySQL practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="15,999" offer="10,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>     
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="MongoDB" coupath2="mongodb" cou1='Cassandra' coupath1='cassandra' cou='PostgreSQL' coupath='postgresql' cou3='Tableau' coupath3='tableau' 
          cou4='Oracle' coupath4='oracle' cou5='Python' coupath5='python' cou6='Alteryx' coupath6='alteryx' cou7='Data Science' coupath7='datascience' cou8='Azure Data Bricks' coupath8='azure-databricks'
           cou9='Power BI' coupath9='power-bi'  cou10='Snowflake' coupath10='snowflake'/>
      </>
    );
  }
}
